import { Box } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Slide from "@mui/material/Slide";
import { forwardRef } from "react";
import ModalHeader from "../ModalHeader";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function AlertDialogSlide({
  close,
  open,
  onConfirm,
  title,
  subTitle,
  okText,
  cancelText,
  removeTitleSpace,
  loading,
  children,
}) {
  title = title?.split(" ");
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={close}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{ sx: { borderRadius: "24px", pb: 3, border: 0 } }}
      sx={{ zIndex: 9999 }}
    >
      <ModalHeader
        primaryText={title[0]}
        secondaryText={title?.slice(1)?.join(" ")}
        sx={{ zIndex: 0 }}
        removeTitleSpace={removeTitleSpace}
      />
      <Box sx={{ px: 3 }}>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description" color={"#000"}>
            {subTitle}
          </DialogContentText>
          {children}
        </DialogContent>
        <DialogActions
          sx={{
            width: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button
            color="secondary"
            onClick={close}
            variant="outlined"
            sx={{ width: 1, mr: 1 }}
            disabled={loading}
          >
            {cancelText}
          </Button>
          <Button
            color="secondary"
            onClick={onConfirm}
            variant="contained"
            sx={{ width: 1, ml: 1 }}
            disabled={loading}
          >
            {okText}
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  );
}
